<template>
    <div class="divider div-transparent" :style="{ margin: margin }"></div>
</template>


<script>
    export default {
        name: "Divider",
        props: ["margin"],
        data() {
            return {};
        }
    };
</script>

<style scoped lang="scss">

    .divider {
        position: relative;
        height: 1px;
    }

    .div-transparent:before {
        content: "";
        position: absolute;
        top: 0;
        left: 5%;
        right: 5%;
        width: 90%;
        height: 1px;
        background-image: linear-gradient(to right, transparent, rgb(150,150,150), transparent);
    }
</style>
